import { Model } from "@vuex-orm/core";
import config from "../configs/MeetingRegister";

export default class MeetingRegister extends Model {
  static get entity() {
    return "meetingRegisters";
  }
  static fields() {
    return {
      id: this.attr(null),
      meeting: this.attr([]),
      mandates: this.attr([]),
      signature: this.attr(null),
      mainMandateId: this.attr(null),
      mainContactId: this.attr(null),
      contactData: this.attr([]),
      timezone: this.attr(null),
      created: this.attr(null),
      updated: this.attr(null),
      agencyId: this.attr(null),
    };
  }
  static get apiConfig() {
    return config;
  }
}
